import { render, staticRenderFns } from "./ElementsPool.vue?vue&type=template&id=200e1ce6&"
import script from "./ElementsPool.vue?vue&type=script&lang=js&"
export * from "./ElementsPool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports